import { z } from 'zod';
import { FollowUpTools } from '../../followUpTools';
import { AiResultType } from '../../types';
import { filtersSchema, filtersSchemaTransformed } from '../filters';
import visualizationMetadataSchema from '../visualizationMetadata';
import { tableVizConfigSchema } from '../visualizations';
export const toolTableVizArgsSchema = visualizationMetadataSchema.extend({
    type: z.literal(AiResultType.TABLE_RESULT),
    vizConfig: tableVizConfigSchema,
    filters: filtersSchema
        .nullable()
        .describe('Filters to apply to the query. Filtered fields must exist in the selected explore.'),
    followUpTools: z
        .array(z.union([
        z.literal(FollowUpTools.GENERATE_BAR_VIZ),
        z.literal(FollowUpTools.GENERATE_TIME_SERIES_VIZ),
    ]))
        .describe('The actions the User can ask for after the AI has generated the table.'),
});
export const toolTableVizArgsSchemaTransformed = toolTableVizArgsSchema.transform((data) => ({
    ...data,
    filters: filtersSchemaTransformed.parse(data.filters),
}));
//# sourceMappingURL=toolTableVizArgs.js.map